var e={hover:"(hover: hover)",md:"(min-width: 30rem)",lg:"(min-width: 64rem)",xl:"(min-width: 100rem)"},r=e;export{r as a};
//# sourceMappingURL=chunk-BBIFT7L4.js.map